/**
 * RefundListContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
import OrderList from 'routes/admin.routes/admin.orders/OrderList';

const RefundListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <OrderList
          purchaseStatus={['REFUNDED', 'RETURNED']}
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default RefundListContainer;
